import React from "react";
import mermaid from "mermaid";


mermaid.initialize({
  startOnLoad: true,
  theme: "default",
  securityLevel: "loose",
  themeCSS: `
    /* General node style */
    .node rect, .node polygon {
      fill: #f9fafb; /* soft light background */
      stroke: #93c5fd; /* light blue border */
      stroke-width: 1.5px;
      rx: 6px;
      ry: 6px;
    }

    /* Node text */
    .node text {
      fill: #1f2937; /* dark gray */
      font-size: 14px;
      font-weight: 500;
    }

    /* Special node types */
    .node.start rect {
      fill: #d1fae5; /* mint green */
      stroke: #34d399;
    }
    .node.end rect {
      fill: #fee2e2; /* light red */
      stroke: #f87171;
    }
    .node.decision polygon {
      fill: #fef9c3; /* pale yellow */
      stroke: #facc15;
    }

    /* Links / arrows */
    .edgePath path {
      stroke: #9ca3af; /* neutral gray */
      stroke-width: 1.5px;
      stroke-dasharray: 4 3; /* dashed lines */
    }

    /* Edge labels */
    .edgeLabel {
      background: #ffffff;
      color: #374151;
      font-size: 12px;
      padding: 2px 4px;
      border-radius: 3px;
      border: 1px solid #e5e7eb;
    }

    /* Hover effect */
    .node:hover rect, .node:hover polygon {
      fill: #e0f2fe; /* very light blue */
      stroke: #3b82f6;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    /* Titles / labels */
    .label text {
      fill: #111827;
      font-weight: 600;
    }
  `,
  fontFamily: "Inter, sans-serif"
});

export default class Mermaid extends React.Component {
  componentDidMount() {
    mermaid.contentLoaded();
  }
  render() {
    return <div className="mermaid">{this.props.chart}</div>;
  }
}
